import { ReactNode } from 'react'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { styled } from '@mui/material/styles'
import { Typography, useTheme } from '@mui/material'
import { BottomDrawer } from '$common/bottom-drawer'
import { SecondaryButton } from '$common/buttons'
import { t } from '$i18n'

export function CompatibilityWarningLayout({
  isOpen,
  icon,
  title,
  description,
  badge,
}: {
  isOpen: boolean
  icon: ReactNode
  title: string
  description: ReactNode
  badge: ReactNode
}) {
  const palette = useTheme().palette
  return (
    <BottomDrawer isOpen={isOpen} onClose={closeCurrentModal}>
      <PageContainer>
        <MainContent>
          <MainIconContainer style={{ backgroundColor: palette.error100 }}>
            {icon}
            {badge && <MainIconBadgeContainer>{badge}</MainIconBadgeContainer>}
          </MainIconContainer>
          <Typography variant="h2">{title}</Typography>
          {description}
        </MainContent>
        <ActionWrapper>
          <SecondaryButton
            fullWidth
            text={t('common.understand')}
            onClick={closeCurrentModal}
          />
        </ActionWrapper>
      </PageContainer>
    </BottomDrawer>
  )
}

const ActionWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 20px;
`

const MainIconContainer = styled('div')`
  width: 140px;
  height: 140px;
  margin-bottom: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

const MainContent = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`

const PageContainer = styled('div')`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: auto;
`

const MainIconBadgeContainer = styled('div')`
  position: absolute;
  bottom: -10px;
  right: -10px;
  width: 52px;
  height: 52px;
  background-color: ${({ theme }) => theme.palette.error500};
  outline: 6px solid ${({ theme }) => theme.palette.neutral000};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`
